import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('hidden')
      
      if (!this.menuTarget.classList.contains('hidden')) {
        this.positionMenu()
        // Add event listener when menu is shown (with small delay to avoid immediate trigger)
        // Use capture phase to catch events before they're stopped by modal handlers
        setTimeout(() => {
          document.addEventListener('click', this.handleOutsideClick, true)
        }, 10)
      } else {
        // Remove event listener when menu is hidden
        document.removeEventListener('click', this.handleOutsideClick, true)
      }
    }
  }

  positionMenu() {
    if (!this.hasMenuTarget) return
    
    const button = this.element.querySelector('button')
    const menu = this.menuTarget
    
    // Get button position relative to viewport
    const buttonRect = button.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    
    // Temporarily show menu to measure its height
    menu.style.visibility = 'hidden'
    menu.classList.remove('hidden')
    const menuHeight = menu.offsetHeight
    const menuWidth = menu.offsetWidth
    menu.classList.add('hidden')
    menu.style.visibility = 'visible'
    
    // Position using fixed positioning to escape table constraints
    menu.style.position = 'fixed'
    menu.style.zIndex = '9999'
    
    // Calculate horizontal position (align to right of button)
    const rightPosition = window.innerWidth - buttonRect.right
    menu.style.right = `${rightPosition}px`
    
    // Calculate vertical position based on available space
    const spaceBelow = viewportHeight - buttonRect.bottom
    const spaceAbove = buttonRect.top
    
    if (spaceBelow >= menuHeight + 8) {
      // Enough space below - position below button
      menu.style.top = `${buttonRect.bottom + 4}px`
      menu.style.bottom = 'auto'
    } else if (spaceAbove >= menuHeight + 8) {
      // Not enough space below but enough above - position above button
      menu.style.bottom = `${viewportHeight - buttonRect.top + 4}px`
      menu.style.top = 'auto'
    } else {
      // Not enough space in either direction - use the side with more space
      if (spaceAbove > spaceBelow) {
        menu.style.bottom = `${viewportHeight - buttonRect.top + 4}px`
        menu.style.top = 'auto'
      } else {
        menu.style.top = `${buttonRect.bottom + 4}px`
        menu.style.bottom = 'auto'
      }
    }
    
    // Reset any Tailwind positioning classes since we're using inline styles
    menu.classList.remove('absolute', 'top-12', 'bottom-12', 'right-0')
    
    // Show the menu
    menu.classList.remove('hidden')
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
      // Reset positioning styles
      this.menuTarget.style.position = ''
      this.menuTarget.style.top = ''
      this.menuTarget.style.bottom = ''
      this.menuTarget.style.right = ''
      this.menuTarget.style.zIndex = ''
      // Restore Tailwind classes
      this.menuTarget.classList.add('absolute', 'right-0')
      document.removeEventListener('click', this.handleOutsideClick, true)
    }
  }

  handleOutsideClick(event) {
    // Check if click is outside the dropdown element
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  // Prevent clicks inside the dropdown from closing it
  stopPropagation(event) {
    event.stopPropagation()
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick, true)
  }
}